import { styled } from '@material-ui/core/styles'

export const OrderedList = styled('ol')(({ theme }) => ({
  paddingLeft: '16px',
  lineHeight: 1.2,
  [theme.breakpoints.up('md')]: {
    paddingLeft: '24px',
    lineHeight: 1.4,
  },
}))

export const TableWrapper = styled('div')(({ theme }) => ({
  overflowX: 'auto',
  margin: '16px 16px 16px -48px',
  '& td': {
    textAlign: 'center',
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: 0,
    marginRight: 0,
  },
}))

export const TableRowHeader = styled('th')({
  textAlign: 'left',
  minWidth: '220px',
  paddingRight: '8px',
})
